import { SimpleModal } from '@festina-life/ui/structure'

import { DetailsLayout } from '../../components/detailsLayout/DetailsLayout'
import { isSpecialCasedSubTemplatedValueSetup } from '../../components/specialCasedSubTemplatedViewers/types'
import { TemplateDetailsContentSelector } from '../../components/templateDetails/content/TemplateDetailsContentSelector'
import { TemplateDetailsTitleSelector } from '../../components/templateDetails/title/TemplateDetailsTitleSelector'
import { useNavigateToCurrentTemplatePath } from '../../components/templateFieldsTable/useNavigateToCurrentTemplatePath'
import { useLayoutContext } from '../../context/layoutContext'
import { useTemplateContext } from '../../context/templateContext'
import {
  isNotRelevantField,
  isTemplateField,
  type TemplateVersionInfo,
} from '../../types/templateModel'

type Props = {
  versionInfo: TemplateVersionInfo
}

export const TemplateDetailsModal = ({ versionInfo }: Props) => {
  const { viewingDetails } = useTemplateContext()
  const {
    preferences: {
      common: { isUsingModal },
    },
  } = useLayoutContext()
  const navigateToPath = useNavigateToCurrentTemplatePath()

  return viewingDetails && isUsingModal ? (
    <SimpleModal
      isOpen={!!viewingDetails}
      title={
        <TemplateDetailsTitleSelector
          data={viewingDetails}
          layer={versionInfo.layer}
          block={versionInfo.block}
        />
      }
      closeConfiguration={{ onClose: () => navigateToPath('') }}
      bodyOuterClassName="min-h-[80vh] h-[80vh] xl:w-[50vw]"
      bodyInnerClassName="p-6 px-3"
    >
      <DetailsLayout
        isNotRelevant={
          isTemplateField(viewingDetails) && isNotRelevantField(viewingDetails)
        }
        shouldSkipLayout={isSpecialCasedSubTemplatedValueSetup(viewingDetails)}
      >
        <TemplateDetailsContentSelector data={viewingDetails} />
      </DetailsLayout>
    </SimpleModal>
  ) : null
}
